<template>
  <div style="width:100%;height:100%;overflow: auto">
    <div style="display: flex;margin-left: 10px;margin-top: 10px">
      <div style="width: 300px;font-size: 18px;"><b>实时数据：</b></div>
      <el-select v-model="company" style="width: 150px;margin-left: 10px;">
        <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div style="width: calc(100% - 20px);display: flex;flex-wrap: wrap;height: auto;
    border: 1px solid #ececec;margin-top: 10px;margin-left: 10px">
      <div style="width: 400px;height: 300px;margin-top: 10px;" v-for="(item,index) in catalogList" :id="'catalogChart-'+ index"/>
    </div>

    <div style="display: flex;margin-left: 10px;margin-top: 10px">
      <div style="width: 300px;font-size: 18px;"><b>Ontimes月度累计</b></div>
      <el-select v-model="ontimeMonthYear" style="width: 150px;margin-left: 10px" @change="initOntimeData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label + '年度'" :value="item.value"></el-option>
      </el-select>
    </div>

    <div style="width: 98%;height: 300px;margin-top: 10px" id="ontimesChart"></div>

    <div style="display: flex;margin-left: 10px;margin-top: 10px">
      <div style="width: 300px;font-size: 18px"><b>Recapture月度累计</b></div>
      <el-select v-model="recaptureMonthYear" style="width: 150px;margin-left: 10px" @change="initRecaptureData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label + '年度'" :value="item.value"></el-option>
      </el-select>
    </div>

    <div style="width: 98%;height: 300px;margin-top: 10px" id="recaptureChart"></div>

    <div style="width: 300px;font-size: 18px;margin-left: 10px"><b>各年度累计维护比例</b></div>
    <div style="width: 98%;height: 300px;margin-top: 10px" id="productCntChart"></div>
    <div style="width: 98%;height: 300px;margin-top: 10px" id="customerCntChart"></div>

    <div style="width: 300px;font-size: 18px;margin-left: 10px"><b>SW维护截止年度</b></div>
    <div style="width: 98%;height: 300px;margin-top: 10px" id="maintenanceDeadlineChart"></div>

    <div style="display: flex;margin-left: 10px;margin-top: 10px">
      <div style="width: 300px;font-size: 18px"><b>SW续订分布</b></div>
      <el-select v-model="swRenewMonthYear" style="width: 150px;margin-left: 10px" @change="initSwRenewChartData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label + '年度'" :value="item.value"></el-option>
      </el-select>
    </div>
    <div style="width: 98%;height: 300px;margin-top: 10px" id="swRenewChart"></div>





  </div>
</template>

<script>
import * as echarts from "echarts";
import dayjs from "dayjs";

export default {
  name: "MaintenanceData",

  data(){
    return {
      company:'summaryData',
      yearList:[],
      companyList:[],
      catalogList:[],
      ontimeMonthYear:'',
      recaptureMonthYear:'',
      swRenewMonthYear:'',

      catalogSeriesData: {},
      ontimeSeriesData:[],
      recaptureSeriesData:[],
      productCntSeriesData:[],
      productLengthData:[],
      customerCntSeriesData:[],
      customerLengthData:[],
      maintenanceDeadlineSeriesData:[],
      maintenanceDeadLengthData:[],
      swRenewSeriesData:[],

    }
  },
  async created() {
    await this.getCompanyList();
    await this.getCatalogList();
    await this.getYearList();
    await this.initCatalogData();
    await this.initOntimeData();
    await this.initRecaptureData();
    await this.initEachYearData();
    await this.initMaintenanceDeadlineData();
    await this.initSwRenewChartData();

  },
  methods:{

    async initCatalogData(){
      await this.getRealTimeData();
      let resultData = this.catalogSeriesData;

      for (let item of this.catalogList){
        let index = this.catalogList.indexOf(item);
        let name = item.name;
        let data = resultData[item.id];
        await this.renderEcharts(data,name,index);

      }

    },

    async getRealTimeData(){
      let params = {company:this.company,catalogList:this.catalogList};
      this.catalogSeriesData = await this.$http('crmBusinessService.getRealTimeData',params);
    },

    async initOntimeData(){
      await this.getOntimeData();
      await this.renderOntimeEcharts();
    },
    async getOntimeData(){
      let params = {company:this.company,year:this.ontimeMonthYear};
      this.ontimeSeriesData = await this.$http('crmBusinessService.getOntimeData',params);
    },
    async initRecaptureData(){
      await this.getRecaptureData();
      await this.renderRecaptureEcharts();
    },
    async getRecaptureData(){
      let params = {company:this.company,year:this.recaptureMonthYear};
      this.recaptureSeriesData = await this.$http('crmBusinessService.getRecaptureData',params);
    },
    async initEachYearData(){
      await this.getEachYearData();
      await this.renderEachYearEcharts();
    },
    async getEachYearData(){
      let params = {company:this.company};
      let data = await this.$http('crmBusinessService.getEachYearData',params);
      this.productCntSeriesData = data.seriesData;
      this.productLengthData = data.lengthData;
      this.customerCntSeriesData = data.customerSeriesData;
      this.customerLengthData = data.customerLengthData;

    },
    async initMaintenanceDeadlineData(){
      await this.getMaintenanceDeadlineData();
      await this.renderMaintenanceDeadlineEcharts();
    },
    async getMaintenanceDeadlineData(){
      let params = {company:this.company};
      let data = await this.$http('crmBusinessService.getMaintenanceDeadlineData',params);
      this.maintenanceDeadlineSeriesData = data.seriesData;
      this.maintenanceDeadLengthData = data.lengthData;
    },
    async initSwRenewChartData(){
      await this.getSwRenewChartData();
      await this.renderSwRenewChartEcharts();
    },
    async getSwRenewChartData(){
      let params = {company:this.company,year:this.swRenewMonthYear};
      this.swRenewSeriesData = await this.$http('crmBusinessService.getSwRenewChartData',params);
    },

    async getYearList(){
      const now = dayjs();
      this.ontimeMonthYear = now.year() + '';
      this.recaptureMonthYear = now.year() + '';
      this.swRenewMonthYear = now.year() + '';
      this.yearList = await this.$http('sysDsService.getYears(10,1)');
    },

    async getCompanyList(){
      let data = await this.$http('crmTeamService.getCompanyList');
      data.unshift({value:'summaryData',label:'汇总数据'})
      this.companyList = data;
    },

    async getCatalogList(){
      this.catalogList = await this.$http('crmBusinessService.getProductCategory');
      if(this.catalogList.length>0){
        this.catalogList.unshift({name:'客户数',id:'customerCnt'})
      }
    },

    renderEcharts(data,name,index){
      const customerChartDom = document.getElementById('catalogChart-' + index);
      // 获取现有的 ECharts 实例（如果有）
      let customerChart = echarts.getInstanceByDom(customerChartDom);

      // 如果存在现有的实例，销毁它
      if (customerChart) {
        customerChart.dispose();
      }
      // 初始化新的 ECharts 实例
      customerChart = echarts.init(customerChartDom);
      customerChart.setOption(this.getCustomerChartOptions(data,name), true);
    },

    getCustomerChartOptions(data,name){
      return{
        title: {
          text: name + "：",
          textStyle: {
            fontSize: 15, // 设置字体大小为 15px
            color: '#0074e0',
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: 'bottom',
          left: 'center'
        },
        label: {
          show: true, // 显示标签
          formatter: function (params) {
            return params.value;
          }
        },
        series: [
          {
            type: 'pie',
            radius: ['35%', '50%'],
            data: data === undefined ? [] : data
          }
        ]
      }
    },
    renderOntimeEcharts(){
      const customerChartDom = document.getElementById('ontimesChart');
      // 获取现有的 ECharts 实例（如果有）
      let customerChart = echarts.getInstanceByDom(customerChartDom);

      // 如果存在现有的实例，销毁它
      if (customerChart) {
        customerChart.dispose();
      }
      // 初始化新的 ECharts 实例
      customerChart = echarts.init(customerChartDom);
      customerChart.setOption(this.getOntimesChartOptions(), true);
    },
    getOntimesChartOptions(){
      return{
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
          }
        ],
        yAxis: [
          {
            type: 'value',
            alignTicks:true
          },
          {
            type: 'value',
            name: '比例',
            max:100,
            min:0,
            interval: 20,
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: this.ontimeSeriesData === undefined ? [] : this.ontimeSeriesData,
      }
    },
    async renderRecaptureEcharts(){
      const customerChartDom = document.getElementById('recaptureChart');
      // 获取现有的 ECharts 实例（如果有）
      let customerChart = echarts.getInstanceByDom(customerChartDom);

      // 如果存在现有的实例，销毁它
      if (customerChart) {
        customerChart.dispose();
      }
      // 初始化新的 ECharts 实例
      customerChart = echarts.init(customerChartDom);
      customerChart.setOption(this.getRecaptureChartOptions(), true);
    },
    getRecaptureChartOptions(){
      return{
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
          }
        ],
        yAxis: [
          {
            type: 'value',
            alignTicks:true
          },
          {
            type: 'value',
            name: '比例',
            max:100,
            min:0,
            interval: 20,
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: this.recaptureSeriesData === undefined ? [] : this.recaptureSeriesData,
      }
    },
    async renderEachYearEcharts(){
      const productCntChartDom = document.getElementById('productCntChart');
      const customerCntChartDom = document.getElementById('customerCntChart');
      // 获取现有的 ECharts 实例（如果有）
      let productCntChart = echarts.getInstanceByDom(productCntChartDom);
      // 获取现有的 ECharts 实例（如果有）
      let customerCntChart = echarts.getInstanceByDom(customerCntChartDom);

      // 如果存在现有的实例，销毁它
      if (productCntChart) {
        productCntChart.dispose();
      }
      // 如果存在现有的实例，销毁它
      if (customerCntChart) {
        customerCntChart.dispose();
      }
      // 初始化新的 ECharts 实例
      productCntChart = echarts.init(productCntChartDom);
      productCntChart.setOption(this.getEachYearChartOptions(this.productLengthData,this.productCntSeriesData,"产品套数："), true);
      // 初始化新的 ECharts 实例
      customerCntChart = echarts.init(customerCntChartDom);
      customerCntChart.setOption(this.getEachYearChartOptions(this.customerLengthData,this.customerCntSeriesData,"客户数："), true);
    },
    getEachYearChartOptions(lengthData,data,name){
      return{
        title: {
          text: name,
          textStyle: {
            fontSize: 15, // 设置字体大小为 15px
            color: '#0074e0',
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: lengthData === undefined ? [] : lengthData
          }
        ],
        yAxis: [
          {
            type: 'value',
            alignTicks:true
          },
          {
            type: 'value',
            name: '比例',
            max:100,
            min:0,
            interval: 20,
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: data === undefined ? [] : data,
      }
    },
    async renderMaintenanceDeadlineEcharts(){
      const productCntChartDom = document.getElementById('maintenanceDeadlineChart');

      // 获取现有的 ECharts 实例（如果有）
      let productCntChart = echarts.getInstanceByDom(productCntChartDom);

      // 如果存在现有的实例，销毁它
      if (productCntChart) {
        productCntChart.dispose();
      }

      // 初始化新的 ECharts 实例
      productCntChart = echarts.init(productCntChartDom);
      productCntChart.setOption(this.getMaintenanceDeadlineChartOptions(), true);
    },
    getMaintenanceDeadlineChartOptions(){
      return{
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data:this.maintenanceDeadLengthData === undefined ? [] : this.maintenanceDeadLengthData,
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: this.maintenanceDeadlineSeriesData === undefined ? [] : this.maintenanceDeadlineSeriesData,
      }
    },
    async renderSwRenewChartEcharts(){
      const productCntChartDom = document.getElementById('swRenewChart');

      // 获取现有的 ECharts 实例（如果有）
      let productCntChart = echarts.getInstanceByDom(productCntChartDom);

      // 如果存在现有的实例，销毁它
      if (productCntChart) {
        productCntChart.dispose();
      }

      // 初始化新的 ECharts 实例
      productCntChart = echarts.init(productCntChartDom);
      productCntChart.setOption(this.getSwRenewChartOptions(), true);
    },
    getSwRenewChartOptions(){
      return{
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: this.swRenewSeriesData === undefined ? [] : this.swRenewSeriesData,
      }
    },
  }
}
</script>

<style scoped>

</style>